import { render, staticRenderFns } from "./DocumentSignatureSender.vue?vue&type=template&id=5d4821b6&scoped=true"
import script from "./DocumentSignatureSender.vue?vue&type=script&lang=js"
export * from "./DocumentSignatureSender.vue?vue&type=script&lang=js"
import style0 from "./DocumentSignatureSender.vue?vue&type=style&index=0&id=5d4821b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4821b6",
  null
  
)

export default component.exports